/**
 * Which form each `json` setting on docs/05-ADMIN-DASHBOARD.md §2's settings
 * screen gets.
 *
 * §8's `type` column picks the control, and `json` is the one value that does
 * not describe a shape: `contact_phones` is a list of telephone numbers,
 * `contact_form_recipients` a list of addresses, `working_hours` the
 * opening-times table. All three were edited as raw JSON in a monospace
 * textarea — an administrator correcting a phone number had to get a pair of
 * brackets, four quotes and a comma right, and a missed one silently kept the
 * old value because the field only wrote through when the text parsed.
 *
 * Keyed by setting rather than by a new `type`, because the shapes belong to
 * these keys rather than to a category — a generic "list of strings" type would
 * still leave `working_hours` needing its own form. Anything else typed `json`
 * falls through to the textarea, which is the honest answer for a shape nobody
 * has designed a form for yet.
 *
 * Its own module so neither component file exports a constant, which is what
 * `react-refresh/only-export-components` is protecting.
 */

/** How one row of a string list should be typed and validated by the browser. */
export type StringListKind = 'tel' | 'email' | 'text';

/** `hours` is the opening-times table; anything else is a list of that input. */
export type SettingJsonEditor = StringListKind | 'hours';

export const SETTING_JSON_EDITORS: Record<string, SettingJsonEditor | undefined> = {
  contact_phones: 'tel',
  contact_form_recipients: 'email',
  working_hours: 'hours',
};
